import { render, staticRenderFns } from "./DemonstracaoReservaUti.vue?vue&type=template&id=63cc1e86&scoped=true"
import script from "./DemonstracaoReservaUti.vue?vue&type=script&lang=ts"
export * from "./DemonstracaoReservaUti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc1e86",
  null
  
)

export default component.exports